class TeknotextKatalog extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.rail = this.querySelector('[data-tk-rail]');
    this.toggle = this.querySelector('[data-tk-filter-toggle]');

    if (this.form) {
      const senden = this.form.querySelector('[data-tk-senden]');
      if (senden) senden.hidden = true;

      this.form.addEventListener('change', (event) => {
        // Preisfelder erst beim Verlassen abschicken: bei jedem getippten
        // Zeichen neu zu laden macht die Eingabe unbenutzbar.
        if (event.target instanceof HTMLInputElement && event.target.type === 'number') return;
        this.form.requestSubmit();
      });

      this.form.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
          event.preventDefault();
          this.form.requestSubmit();
        }
      });
    }

    if (this.toggle && this.rail) {
      this.toggle.hidden = false;
      this.toggle.addEventListener('click', () => {
        const offen = this.rail.hasAttribute('data-offen');
        if (offen) this.rail.removeAttribute('data-offen');
        else this.rail.setAttribute('data-offen', '');
        this.toggle.setAttribute('aria-expanded', String(!offen));
      });
    }
  }
}

if (!customElements.get('teknotext-katalog')) {
  customElements.define('teknotext-katalog', TeknotextKatalog);
}
